import React, { useCallback, useEffect, useState } from "react";
import ReactDom from "react-dom";
import { Slide } from "@mui/material";
import classes from "./Modal.module.css";
import BackgroundOverlay from "../BackgroundOverlay";
import images from "../../assets/images";

const Modal = (props) => {
  const {
    open,
    width = "45%",
    height,
    showCloseIcon = true,
    onClose = () => {},
    onEscape = () => {},
    id = "modal",
    borderRadius = 12,
    top = 40,
    modalStyles = {},
    header,
    content,
    footer,
    children,
  } = props;
  const { close } = images;
  const [margin, setMargin] = useState("0");

  const keyupListener = useCallback(
    (event) => {
      const key = event.key;
      if (key === "Escape") {
        event.stopPropagation();
        event.preventDefault();
        onEscape();
        return;
      }
    },
    [onEscape]
  );
  useEffect(() => {
    if (open) document.addEventListener("keyup", keyupListener, false);
    return () => {
      document.removeEventListener("keyup", keyupListener, false);
    };
  }, [keyupListener, open]);
  useEffect(() => {
    const widthVal = width.split("%")[0];
    setMargin(`0 ${(100 - widthVal) / 2}%`);
  }, [width, open, margin]);

  return ReactDom.createPortal(
    <Slide direction="up" in={open} mountOnEnter unmountOnExit>
      <div
        id={id}
        className={`${classes["modal"]}`}
        style={{
          borderRadius: borderRadius,
          top: top,
          margin: margin,
          height: height,
          width: width,
          boxShadow: "-8px 8px 0px #000",
          ...modalStyles,
        }}
      >
        {open && <BackgroundOverlay />}
        <div
          className={`${classes["modal-header"]} ${
            (header || showCloseIcon) && classes["visible"]
          }`}
        >
          <div className={classes["modal-title"]}>{header}</div>
          <div
            className={`${classes["modal-close-icon"]} ${
              showCloseIcon && classes["visible"]
            }`}
          >
            <img src={close} alt="exit" onClick={onClose} width="20px" />
          </div>
        </div>
        {content && <div className={classes["modal-content"]}>{content}</div>}
        {children && <div className={classes["modal-content"]}>{children}</div>}
        <div
          className={`${classes["modal-footer"]} ${
            footer && classes["visible"]
          }`}
        >
          {footer}
        </div>
      </div>
    </Slide>,
    document.getElementById("modal-overlay")
  );
};

export default Modal;
